import { useState } from "react";
import { Link } from "react-router-dom";
import { AuthLayout, Field } from "./Login";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { toast.error(apiError(err)); }
    finally { setBusy(false); }
  };
  return (
    <AuthLayout title="Mot de passe oublié" subtitle="Recevez un lien de réinitialisation par email">
      {sent ? (
        <div className="text-center" data-testid="forgot-sent">
          <p className="text-sm text-slate-600">Si un compte existe pour <strong>{email}</strong>, un email de réinitialisation vient d'être envoyé. Vérifiez votre boîte de réception (et les spams).</p>
          <Link to="/login" className="inline-block mt-4 text-[#C85A32] font-semibold">Retour à la connexion</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <Field label="Email" type="email" value={email} onChange={setEmail} testid="forgot-email" />
          <button disabled={busy} className="w-full bg-[#C85A32] text-white font-bold py-3 rounded-lg disabled:opacity-50" data-testid="forgot-submit">{busy ? "Envoi..." : "Envoyer le lien"}</button>
          <p className="text-sm text-center text-slate-500"><Link to="/login" className="text-[#C85A32] font-semibold" data-testid="forgot-back">Retour à la connexion</Link></p>
        </form>
      )}
    </AuthLayout>
  );
}
